import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import Header from './components/header';
import Footer from './components/Footer'
// import Content from './components/content';
// import LoginForm from './components/login';
// import HeaderPage from './components/HeaderPage';
// import RegistrationForm from './components/RegistrationForm';
// import WizardForm from './components/Wizard/Wizard.js';
// import Requirements from './components/Requirements.js';
// import CvbuilderTemplates from './components/CvBuilderTemplate.js';
// import TemplateOne from './components/TemplateOne.js';
// import AboutCompany from './components/AboutCompany.jsx';
// import RealtimeVideo from "./components/RealtimeVideo.jsx";
// import RealtimeVoice from "./components/realtimeVoice.jsx";
// import CreateSession from "./components/VoiceSession.jsx";
// import StreamingPage from "./components/RealtimeYoutube.jsx";
// import StreamingLivePage from "./components/RealtimeYoutudeLive.jsx";
import TextToImage from './components/TextToImage.jsx'
import NSFWChecker from './components/NSFWDETEctor.jsx'
// import ImageGenerator from "./components/ImageGenerator.jsx";

// function RedirectHandle() {
//   window.location.href = "https://anuvadini.aicte-india.org";
//   return null;
// }

function Routingpage() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    {/* <Route path="/realtimeVideo" element={<RealtimeVideo />} />
          <Route
            path="/realtimeVoice/:method/:sessionID"
            element={<RealtimeVoice />}
          />
          <Route path="/session" element={<CreateSession />} />
          <Route path="/stream" element={<StreamingPage />} />
          <Route path="/streamlive" element={<StreamingLivePage />} />
          <Route path="/streamlive/:LiveLink" element={<StreamingLivePage />} /> */}
                    <Route
                        path="/speech-to-image-22"
                        element={<TextToImage />}
                    />
                    <Route
                        path="/speech-to-image-22/nsfw"
                        element={<NSFWChecker />}
                    />
                    {/* <Route path="/*" element={<RedirectHandle />} /> */}
                </Routes>
                <Footer />
            </BrowserRouter>
        </>
    )
}

export default Routingpage
